import React from 'react';
import PremiumImage from 'assets/images/dashboard/icon-lock.png';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { SET_MODAL_STATUS } from 'store/actions';

const DowngradePremiumSuccess = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const userDataParse = localStorage.getItem('diologUserData') ? JSON.parse(localStorage.getItem('diologUserData')) : {};
    return (
        <Box className="modal-inner-wrap">
            <Box className="modal-hero">
                <img src={PremiumImage} alt="Premium" width="150" height="150" />
            </Box>
            <Box className="modal-body">
                <Typography variant="h2" component="h2">
                    You’ve downgraded and cancelled your plan.
                </Typography>
                <Typography variant="body1" component="p">
                    You will be able to use premium feature currently and after the remaining days usage of premium you will be
                    automatically downgraded with limited feature.
                </Typography>
            </Box>
            <Box className="modal-footer pt-0">
                <Button
                    variant="contained"
                    onClick={() => {
                        navigate('/dashboard');
                        dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
                    }}
                    style={{ borderRadius: '12px' }}
                >
                    Got it!
                </Button>
            </Box>
        </Box>
    );
};

export default DowngradePremiumSuccess;
